import { MessageCircle } from 'lucide-react';

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/524442049874?text=Hola,%20me%20interesa%20una%20experiencia%20de%20golf%20de%20lujo"
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-8 right-8 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform duration-300 flex items-center justify-center"
      data-testid="whatsapp-button"
      aria-label="WhatsApp"
    >
      <MessageCircle size={24} fill="white" />
    </a>
  );
}
